import React from 'react';
import { ChatSegment } from 'src/api/queries/chat/useChatConversationQueries';
import {
  ISegmentRenderContext,
  renderSegment,
} from 'src/app/chat/segmentKinds';

export interface IMessageSegmentViewProps extends ISegmentRenderContext {
  segment: ChatSegment;
}

/** @registry One segment of a chat message bubble: SQL tool activity, chart, table, memory note card, user text, or assistant markdown. */
export const MessageSegmentView: React.FC<IMessageSegmentViewProps> = ({
  segment,
  ...context
}) => renderSegment(segment, context);
